var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _g, _path85, _path86, _path87, _path88, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.90279 97.2176L28.3629 82.4723C31.0091 80.8262 33.1562 76.3487 33.1562 72.5049V4.49054C33.1562 2.53986 34.6305 2.10775 33.7346 1.40402C33.7006 1.37933 31.6403 0.358716 31.6025 0.342254C31.0881 0.0858428 30.5239 -0.0294706 29.9592 0.00640008C29.3944 0.0422708 28.8464 0.228233 28.3629 0.548022L4.90279 15.2933C2.25664 16.9395 0.113277 21.4211 0.113277 25.2607V93.2751C0.113277 95.3328 0.718075 96.7691 1.68203 97.4358C1.73874 97.4769 4.22231 98.7609 4.28657 98.7856C5.1409 99.0943 3.74605 97.9502 4.90279 97.2176Z",
    fill: "url(#paint0_linear_2164_2691)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M5.10875 15.3715L28.5688 0.626164C29.82 -0.159868 6.40535 15.853 6.40535 15.853C3.75919 17.4991 1.61583 21.9807 1.61583 25.8203C1.61583 25.8203 0.319145 95.4068 0.319145 93.3656V25.3389C0.319145 21.4992 2.46259 17.0341 5.10875 15.3715Z",
    fill: "url(#paint1_radial_2164_2691)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M6.73097 98.1272L30.191 83.3818C32.8371 81.7151 34.9844 77.2541 34.9844 73.4145V5.40003C34.9844 1.55629 32.8371 -0.20918 30.191 1.45342L6.73097 16.1987C4.08481 17.8449 1.94136 22.3265 1.94136 26.1661V94.1805C1.94136 98.0243 4.08481 99.7898 6.73097 98.1272Z",
    fill: "url(#paint2_radial_2164_2691)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.141 98.3617L30.6011 83.6164C33.2473 81.9703 35.3906 77.4928 35.3906 73.649V5.64283C35.3906 1.80321 33.2473 0.0377116 30.6011 1.70031L7.141 16.4662C4.49484 18.1123 2.3477 22.594 2.3477 26.4336V94.4274C2.34014 98.2671 4.49484 100.033 7.141 98.3617Z",
    fill: "url(#paint3_linear_2164_2691)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7422 74.11V6.01327C34.7422 2.64691 32.8521 1.09955 30.5424 2.55639L7.20708 17.2235C4.88602 18.6803 3.0072 22.5735 3.0072 25.9604V94.0571C3.0072 97.4276 4.89736 98.9956 7.20708 97.514L30.5424 82.8469C32.8635 81.3901 34.7422 77.4805 34.7422 74.11Z",
    fill: "url(#paint4_linear_2164_2691)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8125 74.5257V6.77049C33.8125 3.95559 32.2399 2.65514 30.2969 3.88974L7.46056 18.2441C5.51752 19.4787 3.94493 22.7381 3.94493 25.5571V93.2999C3.94493 96.1189 5.51752 97.4153 7.46056 96.1806L30.2969 81.8263C32.2399 80.6205 33.8125 77.3447 33.8125 74.5257Z",
    fill: "url(#paint5_linear_2164_2691)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0285 4.62626C31.8581 3.47808 33.3438 4.39992 33.3438 6.68394V75.2004C33.3438 77.4845 31.8581 80.2706 30.0285 81.4229L7.72515 95.4439C5.89552 96.5962 4.40989 95.6743 4.40989 93.3862V24.8697C4.40989 22.5857 5.89552 19.7996 7.72515 18.6514L30.0285 4.62626Z",
    fill: "url(#paint6_linear_2164_2691)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.71875 42.15V37.5573C1.71408 37.2588 1.64527 36.9657 1.51793 36.7013C1.39059 36.4369 1.20818 36.2086 0.985316 36.0346C0.580832 35.7795 0.251974 36.0346 0.251974 36.6396V41.2282C0.255749 41.5269 0.324093 41.8204 0.451506 42.085C0.57892 42.3495 0.761797 42.5776 0.985316 42.7509C1.3898 43.006 1.71875 42.7385 1.71875 42.15Z",
    fill: "url(#paint7_linear_2164_2691)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.2868 42.6768C1.49471 42.6768 1.57031 42.3928 1.57031 42.15V37.5573C1.56579 37.2888 1.50442 37.0252 1.39099 36.7868C1.27756 36.5484 1.11514 36.3416 0.916341 36.1827C0.852226 36.1406 0.77944 36.1166 0.704626 36.1128C0.496714 36.1128 0.421109 36.3968 0.421109 36.6396V41.2282C0.425632 41.4966 0.487 41.7603 0.60043 41.9987C0.713859 42.2371 0.876283 42.4438 1.07508 42.6027C1.13824 42.6477 1.2114 42.6733 1.2868 42.6768Z",
    fill: "url(#paint8_linear_2164_2691)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1.35112 42.2694V37.6766C1.34647 37.4086 1.28544 37.1454 1.17272 36.9071C1.06001 36.6688 0.898523 36.4619 0.700842 36.3021C0.642448 36.266 0.578319 36.2423 0.51183 36.2322C0.532161 36.1962 0.560549 36.1664 0.594246 36.1456C0.627943 36.1247 0.665866 36.1134 0.704626 36.1128C0.779439 36.1166 0.852226 36.1406 0.916341 36.1827C1.11514 36.3416 1.27756 36.5484 1.39099 36.7868C1.50442 37.0252 1.56579 37.2888 1.57031 37.5573V42.15C1.57031 42.3928 1.49471 42.6768 1.2868 42.6768H1.2604C1.32451 42.5527 1.3559 42.4117 1.35112 42.2694Z",
    fill: "url(#paint9_radial_2164_2691)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72515 18.6514L30.0285 4.62626C31.8581 3.47808 33.3438 4.39992 33.3438 6.68394V75.2004C33.3438 77.4845 31.8581 80.2706 30.0285 81.4229L7.72515 95.4439C5.89552 96.5962 4.40989 95.6743 4.40989 93.3862V24.8697C4.40989 22.5857 5.89552 19.7996 7.72515 18.6514ZM4.70097 93.3862C4.66965 93.9868 4.82546 94.5813 5.14323 95.0735C5.27328 95.2517 5.43983 95.3943 5.62951 95.4901C5.81918 95.5858 6.02679 95.632 6.23576 95.6249C6.71265 95.6026 7.17619 95.4466 7.58155 95.1722L29.8849 81.1512C31.6351 80.0524 33.0564 77.3816 33.0564 75.2004V6.68394C33.0564 5.30529 32.4667 4.44518 31.5179 4.44518C31.041 4.46755 30.5775 4.62349 30.1722 4.89789L7.86885 18.923C6.12238 20.0218 4.70097 22.6885 4.70097 24.8738V93.3862Z",
    fill: "#BCBEC0"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M21.6267 66.2909C20.4919 67.0883 19.6349 68.2763 19.1922 69.6655C18.7311 68.8424 17.8163 68.686 16.7578 69.3527C15.9589 69.9167 15.2936 70.6781 14.816 71.5748C14.3385 72.4716 14.0622 73.4784 14.0096 74.5134C14.0096 77.9785 19.1922 79.0032 19.1922 79.0032C19.1922 79.0032 24.3749 71.4639 24.3749 67.9987C24.3863 66.1016 23.1388 65.3361 21.6267 66.2909Z",
    fill: "url(#paint10_linear_2164_2691)"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.119 66.6445C20.9841 67.4419 20.127 68.6299 19.6844 70.0191C19.2232 69.1961 18.3084 69.0397 17.25 69.7064C16.4511 70.2704 15.7858 71.0317 15.3083 71.9285C14.8307 72.8252 14.5544 73.832 14.5017 74.867C14.5017 78.3321 19.6844 79.3569 19.6844 79.3569C19.6844 79.3569 24.8672 71.8176 24.8672 68.3524C24.8672 66.4553 23.6348 65.6939 22.119 66.6445Z",
    fill: "url(#paint11_linear_2164_2691)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5282 66.8671C21.3933 67.6645 20.5363 68.8525 20.0937 70.2417C20.0044 70.083 19.8892 69.9435 19.7535 69.8302C20.2065 68.5164 21.0363 67.3966 22.12 66.6367C22.9478 66.1181 23.6888 66.1099 24.1953 66.5215C23.9105 66.4515 23.6155 66.4461 23.3287 66.5056C23.0419 66.5651 22.7694 66.6881 22.5282 66.8671Z",
    fill: "url(#paint12_radial_2164_2691)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2525 69.7068C18.0804 69.1841 18.8175 69.1842 19.3203 69.5916C19.0373 69.5204 18.7438 69.5136 18.4582 69.5717C18.1727 69.6298 17.9012 69.7514 17.6608 69.929C16.862 70.493 16.1967 71.2544 15.7191 72.1511C15.2416 73.0479 14.9652 74.0547 14.9126 75.0897C14.9126 76.6988 16.0466 77.7811 17.2298 78.4807C15.8879 77.7976 14.5043 76.6576 14.5043 74.8674C14.5569 73.8325 14.8333 72.8257 15.3108 71.9289C15.7884 71.0321 16.4537 70.2708 17.2525 69.7068Z",
    fill: "url(#paint13_radial_2164_2691)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M21.0013 64.9326L29.7412 82.6245L32.9771 79.5298L34.6328 74.4638L32.9771 67.6734L21.0013 64.9326Z",
    fill: "url(#paint14_linear_2164_2691)"
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9298 24.1373C17.3983 22.6393 20.7929 22.9027 24.5391 25.2443L36.8438 32.977L30.6782 36.8702L18.3697 29.1333C14.7407 26.8534 11.4444 26.5489 8.99485 27.8987L14.9298 24.1373Z",
    fill: "url(#paint15_linear_2164_2691)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2578 37.0186V47.5539L37.0847 43.6772V40.9035L30.6659 36.8704L36.8314 32.9773L43.2578 37.0186Z",
    fill: "url(#paint16_radial_2164_2691)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2578 37.0186L37.0847 40.9035L30.6659 36.8704L36.8314 32.9773L43.2578 37.0186Z",
    fill: "url(#paint17_linear_2164_2691)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6749 36.8701L37.0938 40.9032L30.6749 36.8701Z",
    fill: "url(#paint18_linear_2164_2691)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3634 29.1334L30.6719 36.8703L30.6152 36.9032V47.3726L18.3634 39.6728C15.4791 37.858 13.1354 39.3148 13.1354 42.9198V43.0556L4.70174 37.7921C4.70174 37.7345 4.70174 37.6728 4.70174 37.6151C4.69796 28.1869 10.8143 24.3884 18.3634 29.1334Z",
    fill: "url(#paint19_linear_2164_2691)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6749 36.8701L37.0938 40.9032V43.6769V51.4426L30.6182 47.3725V36.903L30.6749 36.8701Z",
    fill: "url(#paint20_linear_2164_2691)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6749 36.8701L37.0938 40.9032V43.6769V51.4426L30.6182 47.3725V36.903L30.6749 36.8701Z",
    fill: "url(#paint21_linear_2164_2691)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3627 52.739L37.0938 64.513V75.0524L18.3627 63.2784C10.8627 58.5663 4.77662 47.1873 4.70101 37.792L13.1347 43.0555C13.1952 46.6318 15.5162 50.9488 18.3627 52.739Z",
    fill: "url(#paint22_linear_2164_2691)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1377 43.0557C13.1982 46.632 15.5191 50.949 18.3657 52.7392L30.625 60.4431V70.9743L18.3732 63.2745C10.8733 58.5624 4.78714 47.1834 4.71153 37.7881L13.1377 43.0557Z",
    fill: "url(#paint23_linear_2164_2691)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6258 60.4429L37.0938 64.513V75.0524L30.6182 70.9782V60.447L30.6258 60.4429Z",
    fill: "url(#paint24_linear_2164_2691)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6258 60.4429L37.0938 64.513V75.0524L30.6182 70.9782V60.447L30.6258 60.4429Z",
    fill: "url(#paint25_linear_2164_2691)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2578 71.1634L40.3622 69.3444L43.2578 67.5049V71.1634Z",
    fill: "url(#paint26_radial_2164_2691)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1295 43.0597V42.9198C13.1295 39.3147 15.4732 37.8579 18.3575 39.6728L18.5391 39.7839L13.1409 43.0515L13.1295 43.0597Z",
    fill: "url(#paint27_linear_2164_2691)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0998 64.5129L18.3688 52.7389C15.5223 50.9528 13.2013 46.6358 13.1408 43.0596L18.539 39.792L19.3933 40.3311C19.8545 43.6234 21.9789 47.2573 24.5268 48.8581L43.2578 60.6321V67.4965L40.3622 69.3361L37.0885 67.2784L37.0998 64.5129Z",
    fill: "url(#paint28_radial_2164_2691)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1513 43.0515L18.5495 39.7839L19.4038 40.323C19.865 43.6153 21.9894 47.2492 24.5373 48.8501L36.7891 56.554L30.6273 60.443L18.3679 52.7391C15.5214 50.953 13.2004 46.636 13.1399 43.0598L13.1513 43.0515Z",
    fill: "url(#paint29_linear_2164_2691)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2578 60.624V67.5049L40.3622 69.3445L37.0847 67.2827V64.513L30.6167 60.443L36.7785 56.554L43.2578 60.624Z",
    fill: "url(#paint30_linear_2164_2691)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2578 60.624L37.0847 64.513L30.6167 60.443L36.7785 56.554L43.2578 60.624Z",
    fill: "url(#paint31_linear_2164_2691)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0928 75.0318L43.2734 71.0893V60.5911L37.0928 64.4924V75.0318Z",
    fill: "url(#paint32_linear_2164_2691)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0928 51.443L43.2734 47.5046V37.0022L37.0928 40.9035V51.443Z",
    fill: "url(#paint33_linear_2164_2691)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M22.5608 32.4049C21.8237 33.9852 25.0444 37.3762 29.7432 39.9771C34.4421 42.578 38.8687 43.4093 39.6059 41.829C40.343 40.2487 37.1223 36.8577 32.4234 34.2568C27.7246 31.6559 23.2942 30.8246 22.5608 32.4049Z",
    fill: "url(#paint34_radial_2164_2691)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M22.5608 56.2864C21.8237 57.8667 25.0444 61.2578 29.7432 63.8628C34.4421 66.4678 38.8687 67.295 39.6059 65.7147C40.343 64.1344 37.1223 60.7434 32.4234 58.1384C27.7246 55.5333 23.2942 54.7061 22.5608 56.2864Z",
    fill: "url(#paint35_radial_2164_2691)"
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M8.76795 27.7792L8.68858 27.8162L14.6235 24.063C17.092 22.5651 20.4866 22.8284 24.2328 25.1701L27.1172 26.9849L20.6908 30.7464V41.2529L18.0446 39.6067L18.2261 39.7178L19.0804 40.2569C19.5416 43.5492 21.666 47.1831 24.2139 48.784L27.0491 50.533L20.6795 54.5496V64.8667L18.0333 63.2206C10.5333 58.5085 4.44711 47.1296 4.3715 37.7342C4.3715 37.6766 4.3715 37.6149 4.3715 37.5573C4.39796 32.5983 6.08021 29.2072 8.76795 27.7792Z",
    fill: "url(#paint36_linear_2164_2691)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M43.2734 37.0021L37.0398 40.5701L21.0003 30.8208L36.8811 41.0022L37.0928 51.4428L37.2364 40.8705L43.2734 37.0021Z",
    fill: "url(#paint37_radial_2164_2691)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M43.2734 60.6734L37.0398 64.2373L21.0003 54.488L36.8811 64.6694L37.0928 75.1101L37.2364 64.5377L43.2734 60.6734Z",
    fill: "url(#paint38_radial_2164_2691)"
  }), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5625 51.385C91.5625 53.3356 90.9425 54.7225 89.937 55.3892L88.1868 56.5703C87.1397 57.2082 87.8088 55.7472 86.2211 54.7595C83.0192 52.7513 80.426 47.8787 80.426 43.8786C80.426 41.9032 78.7438 41.8867 79.772 41.2241L81.7226 40.0142C82.7659 39.401 84.1948 39.5122 85.7674 40.4999C88.9541 42.5123 91.5625 47.3848 91.5625 51.385Z",
    fill: "url(#paint39_linear_2164_2691)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7863 51.5599C77.5094 47.3197 77.487 42.7217 79.7364 41.2902C81.9857 39.8587 85.655 42.1356 87.932 46.3759C90.2089 50.6161 90.2312 55.2139 87.9818 56.6455C85.7325 58.077 82.0632 55.8001 79.7863 51.5599Z",
    fill: "url(#paint40_linear_2164_2691)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M84.1347 41.5696C82.5999 40.6025 81.2088 40.475 80.1692 41.0388C81.1369 40.7425 82.3352 40.9647 83.6356 41.7795C86.8337 43.7919 89.4308 48.6645 89.4308 52.6605C89.4308 54.7429 88.7238 56.175 87.6011 56.7759C89.0149 56.3643 89.9297 54.8128 89.9297 52.4383C89.9297 48.4628 87.3365 43.5903 84.1347 41.5696Z",
    fill: "url(#paint41_radial_2164_2691)"
  }), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6512 43.463C86.1462 45.0268 88.1875 48.8129 88.1875 51.9488C88.1875 55.0847 86.1613 56.3193 83.6512 54.7555C81.1412 53.1917 79.115 49.3808 79.115 46.2655C79.115 43.1502 81.1601 41.895 83.6512 43.463ZM82.3244 46.1174C81.9463 45.891 81.6666 46.0721 81.6666 46.5289C81.6799 46.7764 81.7463 47.017 81.8605 47.2314C81.9748 47.4458 82.1337 47.6281 82.3244 47.7635C82.7024 47.9899 82.9821 47.8088 82.9821 47.352C82.9688 47.1045 82.9024 46.8639 82.7881 46.6495C82.6739 46.435 82.5151 46.2528 82.3244 46.1174ZM84.9705 47.7923C84.5925 47.5619 84.3128 47.7429 84.3128 48.2039C84.3261 48.4513 84.3924 48.6919 84.5067 48.9064C84.6209 49.1208 84.7798 49.303 84.9705 49.4385C85.3485 49.6648 85.6283 49.4837 85.6283 49.0269C85.6175 48.7803 85.5533 48.5399 85.4409 48.3253C85.3286 48.1108 85.1713 47.9282 84.9819 47.7923H84.9705ZM83.6512 52.99C84.7362 53.669 85.7304 53.4468 86.1235 52.4303L85.5149 51.7554C85.22 52.5209 84.4715 52.6896 83.6512 52.1669C82.7178 51.5103 82.0436 50.4975 81.7611 49.3273L81.1449 49.2121C81.5227 50.7688 82.4205 52.1159 83.6626 52.99H83.6512Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3972 97.016L62.4766 98.3988L55.7402 94.3945L55.657 92.9294L62.3972 97.016Z",
    fill: "url(#paint42_linear_2164_2691)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3942 97.0158L62.4736 98.4027L68.7109 92.0815L68.6278 90.6165L62.3942 97.0158Z",
    fill: "url(#paint43_linear_2164_2691)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M68.625 90.6168L62.3914 97.0162L55.6588 92.9296L61.9113 86.5549L68.625 90.6168Z",
    fill: "url(#paint44_linear_2164_2691)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M55.6588 92.9293L62.3423 96.7524L68.625 90.6165L62.3914 97.0158L55.6588 92.9293Z",
    fill: "url(#paint45_radial_2164_2691)"
  }), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M61.226 93.3328C61.395 93.0759 61.4862 92.7681 61.4868 92.4521C61.4868 92.2752 61.2941 92.164 61.0786 92.197C60.7978 92.2402 60.5126 92.2402 60.2318 92.197C60.1516 92.2521 60.0611 92.2871 59.9669 92.2992C59.8727 92.3113 59.7772 92.3002 59.6874 92.2669C59.54 92.1723 59.4834 92.0241 59.5438 91.913C58.9503 91.5015 58.6517 90.9294 59.4228 90.1475C59.6979 89.833 60.0635 89.6304 60.459 89.5735C60.8544 89.5166 61.2558 89.6088 61.5965 89.8348C61.6702 89.7984 61.7509 89.7817 61.8317 89.786C61.9126 89.7903 61.9913 89.8155 62.0614 89.8594C62.0912 89.885 62.1159 89.9168 62.1342 89.953C62.1524 89.9892 62.1638 90.029 62.1677 90.07C62.1715 90.1111 62.1679 90.1526 62.1568 90.192C62.1457 90.2315 62.1274 90.2681 62.1031 90.2998C62.2205 90.497 62.2894 90.7237 62.3034 90.9582C62.3034 91.1311 62.4924 91.2504 62.7078 91.2134C63.067 91.1497 63.4113 91.0098 63.721 90.8019C63.9193 90.6636 64.1469 90.5834 64.382 90.569C64.6171 90.5545 64.8516 90.6064 65.0629 90.7195L65.7207 91.1311C65.7488 91.1503 65.772 91.1771 65.788 91.2087C65.8041 91.2404 65.8125 91.276 65.8125 91.3122C65.8125 91.3483 65.8041 91.3839 65.788 91.4156C65.772 91.4472 65.7488 91.474 65.7207 91.4932L62.5188 94.732C62.4615 94.7933 62.3878 94.8332 62.3082 94.8458C62.2287 94.8583 62.1476 94.843 62.0766 94.802L61.4226 94.3904C61.3396 94.3413 61.2674 94.273 61.2113 94.1903C61.1551 94.1075 61.1162 94.0124 61.0975 93.9116C61.0787 93.8107 61.0805 93.7067 61.1027 93.6067C61.1249 93.5067 61.167 93.4132 61.226 93.3328Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9141 65.6777V67.0563L49.8947 60.3565V58.9038L60.9141 65.6777Z",
    fill: "url(#paint46_linear_2164_2691)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9169 65.6777V67.0563L69.3203 61.7681V60.3113L60.9169 65.6777Z",
    fill: "url(#paint47_linear_2164_2691)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3203 60.3112L60.9169 65.6776L49.9051 58.9037L58.3312 53.562L69.3203 60.3112Z",
    fill: "url(#paint48_linear_2164_2691)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M49.9051 58.9038L60.8753 65.4102L69.3203 60.3113L60.9169 65.6777L49.9051 58.9038Z",
    fill: "url(#paint49_radial_2164_2691)"
  }), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2836 56.447C56.4591 56.3492 56.6534 56.2981 56.8506 56.2981C57.0478 56.2981 57.2422 56.3492 57.4177 56.447L59.6556 57.8545L60.7897 57.1343C61.0545 56.9882 61.3472 56.9121 61.644 56.9121C61.9409 56.9121 62.2335 56.9882 62.4983 57.1343C62.5307 57.1467 62.5589 57.1698 62.5788 57.2004C62.5987 57.231 62.6094 57.2676 62.6094 57.3051C62.6094 57.3425 62.5987 57.3791 62.5788 57.4097C62.5589 57.4403 62.5307 57.4634 62.4983 57.4759L61.5268 58.089C61.406 58.1489 61.3008 58.2404 61.2203 58.3552C61.1398 58.4701 61.0867 58.6049 61.0656 58.7475L60.9787 60.2084L58.5026 61.764C58.3443 61.8509 58.1695 61.8961 57.9923 61.8961C57.815 61.8961 57.6403 61.8509 57.482 61.764L56.2722 61.0027L54.7601 60.0562L53.955 59.5459C53.6526 59.3566 53.6223 59.0479 53.9096 58.8504C54.0644 58.7493 54.2397 58.6913 54.42 58.6817C54.1251 58.4882 54.1289 58.1796 54.42 57.9862C54.6604 57.8496 54.9359 57.8047 55.2025 57.8586C54.8963 57.6652 54.8698 57.3483 55.1722 57.1507C55.4625 56.9821 55.8021 56.9451 56.1173 57.0478C55.9812 56.8421 56.0228 56.6034 56.2836 56.447Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8369 62.6155L59.971 63.3398C60.1012 63.4193 60.2468 63.4641 60.396 63.4706C60.5451 63.477 60.6936 63.4449 60.8291 63.3768L63.6718 61.5908C63.8911 61.4509 63.8647 61.2122 63.6114 61.0517L62.4773 60.3274C62.3471 60.2479 62.2015 60.203 62.0523 60.1966C61.9032 60.1902 61.7548 60.2223 61.6192 60.2903L58.7765 62.0764C58.5572 62.2122 58.5836 62.455 58.8369 62.6155Z",
    fill: "url(#paint50_linear_2164_2691)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5475 83.3201H98.4844V84.2337C98.4844 84.2625 98.4844 84.4641 98.4844 84.4929C98.4844 87.9828 94.0199 90.8141 88.5159 90.8141C83.0119 90.8141 78.5475 87.9828 78.5475 84.4929C78.5475 84.4641 78.5475 84.2625 78.5475 84.2337V83.3201Z",
    fill: "url(#paint51_linear_2164_2691)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5159 88.8058C83.0105 88.8058 78.5475 86.37 78.5475 83.3653C78.5475 80.3606 83.0105 77.9248 88.5159 77.9248C94.0213 77.9248 98.4844 80.3606 98.4844 83.3653C98.4844 86.37 94.0213 88.8058 88.5159 88.8058Z",
    fill: "url(#paint52_linear_2164_2691)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M88.5166 88.6742C93.8807 88.6742 98.2507 86.205 98.4737 83.3242C98.4775 83.4024 98.4775 83.4807 98.4737 83.5588C98.4737 86.5589 94.0092 88.9952 88.5052 88.9952C83.0012 88.9952 78.5368 86.5589 78.5368 83.5588C78.5331 83.4807 78.5331 83.4024 78.5368 83.3242C78.7825 86.2255 83.1524 88.6742 88.5166 88.6742Z",
    fill: "url(#paint53_radial_2164_2691)"
  }), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1384 83.0196C83.6469 83.3283 83.6431 83.8427 84.1384 84.1308C84.413 84.2829 84.7167 84.3622 85.0248 84.3622C85.3329 84.3622 85.6367 84.2829 85.9113 84.1308C86.4027 83.8221 86.4065 83.3077 85.9113 83.0155C85.6364 82.864 85.3325 82.7854 85.0243 82.7861C84.7162 82.7869 84.4127 82.8669 84.1384 83.0196Z",
    fill: "#25054D"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7398 80.756C87.2484 81.0646 87.2446 81.5791 87.7398 81.8713C88.0144 82.0234 88.3183 82.1027 88.6264 82.1027C88.9345 82.1027 89.2382 82.0234 89.5128 81.8713C90.0043 81.5626 90.008 81.0482 89.5128 80.7601C89.2385 80.6073 88.9349 80.5273 88.6268 80.5266C88.3187 80.5259 88.0147 80.6045 87.7398 80.756Z",
    fill: "#25054D"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4399 85.9541C93.9067 85.0322 94.33 83.6166 93.5059 82.4272L92.3718 82.7441C92.9993 83.6413 92.6743 84.7071 91.5667 85.4026C90.2287 86.1421 88.686 86.3137 87.2383 85.8841L86.7015 86.5879C88.6181 87.1599 90.9278 86.9047 92.4399 85.9541Z",
    fill: "#25054D"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7545 46.2244L44.335 44.9445C44.335 44.9445 45.624 44.2243 45.7979 44.1544C46.0053 44.0643 46.2278 44.0221 46.451 44.0306C46.6742 44.0391 46.8933 44.0981 47.0945 44.2038C47.41 44.4006 47.6688 44.6894 47.8418 45.0377C48.0147 45.3859 48.095 45.7798 48.0736 46.175L48.497 45.9651C48.6218 45.8869 48.9166 45.7552 48.9166 45.7552C49.3115 45.6083 49.7438 45.638 50.1187 45.8375C51.0637 46.3478 51.3813 47.8335 50.8332 49.1586C50.4741 50.0229 49.6689 50.7389 48.7843 51.2986V51.3192L46.7846 52.4139L46.7278 52.2287C46.2666 52.3974 45.9718 52.4797 45.9718 52.4797C45.9718 52.4797 44.403 48.7512 44.7545 46.2244Z",
    fill: "url(#paint54_linear_2164_2691)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M45.907 44.8622C46.2381 45.0738 46.5064 45.3845 46.68 45.7573C46.8536 46.1301 46.9251 46.5494 46.8861 46.9652C47.1423 46.6692 47.4758 46.4659 47.8415 46.3828C48.2072 46.2996 48.5875 46.3406 48.9312 46.5001C49.8762 47.0145 50.1938 48.5002 49.6457 49.8212C48.6439 52.2369 44.1832 53.4798 44.1832 53.4798C44.1832 53.4798 42.2024 48.7471 43.2079 46.3314C43.7561 45.0022 44.9657 44.3437 45.907 44.8622Z",
    fill: "url(#paint55_linear_2164_2691)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M46.7258 47.0723C46.7663 46.6563 46.6955 46.2365 46.5218 45.8634C46.3481 45.4902 46.0789 45.1798 45.7468 44.9694C45.5511 44.8664 45.3381 44.8082 45.121 44.7983C44.9038 44.7884 44.6871 44.827 44.4842 44.9118C44.7215 44.7471 44.9931 44.6503 45.2739 44.6302C45.5547 44.61 45.8357 44.6673 46.0908 44.7965C46.4077 44.9977 46.6669 45.291 46.8392 45.6435C47.0115 45.9961 47.09 46.394 47.0661 46.7925C46.9461 46.8758 46.8322 46.9694 46.7258 47.0723Z",
    fill: "url(#paint56_radial_2164_2691)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M49.4813 49.9281C50.0332 48.6071 49.7119 47.1214 48.7707 46.607C48.574 46.5051 48.3604 46.4475 48.1428 46.4376C47.9252 46.4277 47.708 46.4657 47.5043 46.5494C47.7422 46.3861 48.0139 46.2904 48.2945 46.271C48.5752 46.2516 48.8559 46.3091 49.1108 46.4383C50.0559 46.9486 50.3735 48.4342 49.8254 49.7553C49.3113 50.9899 47.8974 51.9158 46.6348 52.529C47.8029 51.9199 49.0163 51.0351 49.4813 49.9281Z",
    fill: "url(#paint57_radial_2164_2691)"
  }), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4202 44.3353L59.4232 38.652C58.3534 37.9812 57.4877 38.6932 57.4877 40.2488V41.7797C57.4877 43.3312 58.3534 45.1337 59.4232 45.8086L62.78 47.9157L64.2695 52.6813L65.7513 49.8005L68.4202 51.5084C69.49 52.1833 70.3594 51.4673 70.3594 49.9158V48.3848C70.3594 46.8128 69.49 45.0061 68.4202 44.3353Z",
    fill: "url(#paint58_linear_2164_2691)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3672 50.1586L65.7624 49.78L64.2805 52.669L65.4675 51.9036L66.3672 50.1586Z",
    fill: "url(#paint59_linear_2164_2691)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4123 43.6975L60.4267 38.0142C60.2515 37.8819 60.0485 37.7997 59.8364 37.7753C59.6244 37.7508 59.4101 37.7849 59.2133 37.8743L58.1548 38.5492C58.3548 38.4361 58.5798 38.3854 58.8046 38.4028C59.0295 38.4203 59.2455 38.5051 59.4288 38.648L68.4182 44.3313C69.488 45.0021 70.3574 46.8005 70.3574 48.3602V49.8911C70.3805 50.1854 70.3441 50.4817 70.2507 50.759C70.1573 51.0362 70.0092 51.2879 69.8168 51.4961L70.4066 51.0846C70.7111 50.916 70.9634 50.6537 71.1321 50.3303C71.3008 50.0069 71.3784 49.6367 71.3554 49.2656V47.7429C71.3516 46.175 70.4821 44.3683 69.4123 43.6975Z",
    fill: "url(#paint60_linear_2164_2691)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M68.5336 44.2366L59.5442 38.5533C59.3482 38.3964 59.1128 38.3084 58.8696 38.301C58.6264 38.2937 58.387 38.3674 58.1833 38.5122C58.3725 38.4467 58.573 38.4289 58.7695 38.4603C58.966 38.4917 59.1533 38.5713 59.3173 38.6933L68.3067 44.3724C69.3765 45.0474 70.2422 46.8416 70.2422 48.4055V49.9323C70.2699 50.2364 70.2324 50.5433 70.1327 50.8289C70.033 51.1146 69.8738 51.3711 69.6676 51.5784C70.1591 51.3768 70.4766 50.7554 70.4766 49.8047V48.2738C70.469 46.7141 69.6034 44.9074 68.5336 44.2366Z",
    fill: "url(#paint61_radial_2164_2691)"
  }), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2109 48.1914L64.1583 46.9609V47.4177L66.2109 48.6482V48.1914Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1268 42.9363L65.1719 44.1709V43.7141L63.1268 42.4795V42.9363Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M63.187 45.3726V45.8294L65.3984 47.1504V46.6936L63.187 45.3726Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4922 45.3434V44.8866L64.6908 44.3845V44.8413L65.4922 45.3434Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6996 44.6646V45.1214L68 45.9238V45.467L66.6996 44.6646Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5154 43.5288L64.2656 44.5782V44.1214L62.5154 43.072V43.5288Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7578 45.8085V45.3517L63.4574 44.5945V45.0513L64.7578 45.8085Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7422 47.1543V46.6975L63.3831 46.4712V46.928L63.7422 47.1543Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1817 45.6113V46.0681L66.5312 46.9035V46.4509L65.1817 45.6113Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7734 45.5702V45.1134L62.2971 44.8088V45.2656L62.7734 45.5702Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9002 45.1462V45.603L67.5938 46.636V46.1792L65.9002 45.1462Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6358 48.9078L67.3125 49.3317V48.8748L66.6358 48.4551V48.9078Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5897 44.4302L66.2891 44.8623V44.4055L65.5897 43.9775V44.4302Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1641 42.2202L59.3533 41.0762V41.533L61.1641 42.677V42.2202Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M60.75 42.9075L60.0809 42.4795V42.9363L60.75 43.3602V42.9075Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M61.875 44.5495L58.7525 42.5947V43.0515L61.875 45.0063V44.5495Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0391 44.3355L61.1527 43.1667V43.6236L63.0391 44.7923V44.3355Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9609 46.6647V46.2079L61.4602 45.2737V45.7305L62.9609 46.6647Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5799 42.9363L62.1016 43.2655V42.8087L61.5799 42.4795V42.9363Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9418 47.1668L69.0625 48.4796V48.0228L66.9418 46.71V47.1668Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8239 47.4097L68.1562 48.8624V48.4056L65.8239 46.9529V47.4097Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7022 79.3818V77.995L57.685 78.4065L66.5573 72.8467C66.8813 72.668 67.2393 72.575 67.6025 72.575C67.9657 72.575 68.3237 72.668 68.6477 72.8467L73.8682 76.1389L74.6016 75.5463V76.9456C74.5984 77.0953 74.5562 77.2409 74.4799 77.3655C74.4036 77.49 74.2964 77.5885 74.1707 77.6493L68.2773 81.3531V85.0569L65.3514 83.2173L64.7617 83.5877C64.4381 83.7654 64.0808 83.8579 63.7184 83.8579C63.356 83.8579 62.9986 83.7654 62.675 83.5877L57.1445 80.1103C57.0114 80.0524 56.8977 79.9516 56.8186 79.8214C56.7396 79.6912 56.699 79.5379 56.7022 79.3818Z",
    fill: "url(#paint62_linear_2164_2691)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1307 77.2872L66.5587 71.3611C66.8827 71.1824 67.2407 71.0894 67.6039 71.0894C67.9671 71.0894 68.3251 71.1824 68.6491 71.3611L74.172 74.8344C74.7466 75.1925 74.7428 75.7809 74.172 76.1472L68.2786 79.851V83.5549L65.3527 81.7153L64.7631 82.0857C64.4395 82.2633 64.0821 82.3558 63.7197 82.3558C63.3573 82.3558 63 82.2633 62.6764 82.0857L57.1459 78.6082C56.5524 78.2378 56.5524 77.6493 57.1307 77.2872Z",
    fill: "url(#paint63_linear_2164_2691)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M67.027 75.1554C67.027 75.5382 67.5222 75.8509 68.1308 75.8468C68.7394 75.8427 69.2422 75.534 69.2422 75.1513C69.2422 74.7686 68.7508 74.4558 68.1384 74.4558C67.526 74.4558 67.0308 74.7686 67.027 75.1554Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4845 76.76C64.4826 76.3759 64.9769 76.0616 65.5886 76.058C66.2003 76.0544 66.6978 76.3628 66.6997 76.7469C66.7016 77.131 66.2072 77.4453 65.5955 77.4489C64.9838 77.4525 64.4864 77.1441 64.4845 76.76Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9255 78.3651C61.9255 78.7478 62.4206 79.0606 63.0293 79.0565C63.6379 79.0524 64.1406 78.7438 64.1406 78.361C64.1406 77.9783 63.6492 77.6655 63.0368 77.6655C62.4244 77.6655 61.9292 77.9783 61.9255 78.3651Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3281 81.7026V83.1842L68.2578 85.0237V83.5422L65.3281 81.7026Z",
    fill: "url(#paint64_linear_2164_2691)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M57.118 78.5379L62.6485 82.0154C62.9721 82.1931 63.3294 82.2856 63.6918 82.2856C64.0543 82.2856 64.4116 82.1931 64.7352 82.0154L65.3249 81.645L68.2508 83.4846V79.7808L74.1441 76.077C74.3366 75.9708 74.4842 75.7881 74.5562 75.5667C74.6356 75.8547 74.4995 76.1634 74.1441 76.3897L68.2508 80.0935V83.7974L65.3249 81.9578L64.7352 82.3282C64.4116 82.5058 64.0543 82.5983 63.6918 82.5983C63.3294 82.5983 62.9721 82.5058 62.6485 82.3282L57.118 78.8507C56.7702 78.6326 56.6342 78.3322 56.7098 78.0276C56.7787 78.2497 56.9254 78.4331 57.118 78.5379Z",
    fill: "url(#paint65_radial_2164_2691)"
  }), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5121 68.291V67.2087L89.2399 67.1429C88.8128 66.1963 87.8941 65.2086 86.537 64.3568C83.4637 62.4226 79.3054 61.8876 77.249 63.1962C76.9413 63.381 76.6733 63.6349 76.4627 63.9411L76.1111 63.8506V65.0276C76.0695 66.2951 77.1129 67.8137 79.0824 69.0483C79.3999 69.2499 79.7289 69.431 80.0653 69.5997C79.9141 71.1265 82.2767 72.9826 82.2767 72.9826C82.5879 72.1152 83.1107 71.3568 83.7888 70.7891C85.5957 71.073 87.2931 70.8961 88.3894 70.2088C88.7099 70.0428 88.9839 69.7867 89.1833 69.467C89.3826 69.1472 89.5001 68.7754 89.5234 68.3898L89.5121 68.291Z",
    fill: "url(#paint66_linear_2164_2691)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M88.379 69.1429C90.4317 67.8548 89.6076 65.2374 86.5342 63.3073C83.4609 61.3772 79.3026 60.8587 77.2462 62.1468C75.1898 63.4349 76.0177 66.0523 79.091 67.9865C79.4085 68.184 79.7375 68.3692 80.0739 68.538C79.9227 70.0606 82.2853 71.9166 82.2853 71.9166C82.5963 71.0503 83.1192 70.2931 83.7974 69.7273C85.5854 69.9989 87.2828 69.826 88.379 69.1429Z",
    fill: "url(#paint67_linear_2164_2691)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1654 72.6326V71.5133L41.9987 71.9906L43.9947 71.5791C44.0874 71.5695 44.1773 71.5385 44.2581 71.4881C44.3389 71.4377 44.4089 71.3692 44.4634 71.2869L45.5106 69.1881C45.6845 68.8383 46.4216 68.7765 46.7581 69.0605L48.7654 70.8507C48.936 70.9824 49.1425 71.0476 49.3513 71.0359L52.8443 71.003H52.8631L53.57 70.2334V71.4063C53.5723 71.4646 53.5605 71.5226 53.536 71.5745C53.5115 71.6264 53.475 71.6706 53.4301 71.7025L51.3322 73.4639C51.2684 73.5037 51.2216 73.5691 51.2018 73.6461C51.182 73.7231 51.1908 73.8055 51.2263 73.8755L51.8538 75.0442L52.368 74.9537V76.0443C52.3755 76.0795 52.3755 76.1161 52.368 76.1513C52.2961 76.4064 51.8802 76.5916 51.4455 76.5011L48.1416 75.8014C47.9235 75.7559 47.698 75.7787 47.4914 75.8673L44.6865 77.1842C44.2178 77.4064 43.5524 77.1842 43.5524 76.8262L43.6091 74.6327C43.6091 74.4845 43.5033 74.3487 43.3105 74.2664L40.4678 73.003C40.2297 72.9413 40.1427 72.7849 40.1654 72.6326Z",
    fill: "url(#paint68_linear_2164_2691)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9997 70.4392L40.6618 71.0935C40.1024 71.2046 39.9852 71.6697 40.4615 71.8796L43.3042 73.143C43.497 73.2253 43.6066 73.3652 43.6028 73.5092L43.5499 75.7274C43.5499 76.0937 44.2077 76.3036 44.684 76.0855L47.4889 74.7644C47.6955 74.6758 47.921 74.653 48.1391 74.6986L51.443 75.3982C51.9949 75.5175 52.5242 75.1842 52.3389 74.8344L51.2276 72.7767C51.192 72.7067 51.1832 72.6243 51.203 72.5473C51.2228 72.4703 51.2697 72.4049 51.3334 72.3652L53.4314 70.6038C53.7792 70.3075 53.4314 69.8919 52.8606 69.896L49.3676 69.9289C49.1587 69.9406 48.9524 69.8754 48.7818 69.7437L46.7744 67.9576C46.438 67.6572 45.7008 67.7313 45.527 68.0852L44.4798 70.1799C44.4205 70.2568 44.3473 70.3196 44.2647 70.3642C44.1821 70.4088 44.0918 70.4343 43.9997 70.4392Z",
    fill: "url(#paint69_linear_2164_2691)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.219 84.3694C51.1845 84.2991 51.1762 84.2171 51.1959 84.1404C51.2157 84.0637 51.2619 83.9983 51.3249 83.9578L53.4229 82.1964C53.4678 82.165 53.5039 82.1207 53.5272 82.0685C53.5505 82.0162 53.5602 81.958 53.5552 81.9001H53.5779V83.073C53.5801 83.1314 53.5683 83.1893 53.5438 83.2413C53.5193 83.2932 53.4828 83.3373 53.4379 83.3693L51.5478 84.9579L51.219 84.3694Z",
    fill: "url(#paint70_linear_2164_2691)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6841 87.6905L47.489 86.3695C47.6956 86.2809 47.9211 86.2581 48.1392 86.3036L51.4431 87.0032C51.9043 87.102 52.3466 86.8839 52.3693 86.5917V87.6781C52.3769 87.7133 52.3769 87.75 52.3693 87.7851C52.2975 88.0403 51.8816 88.2255 51.4469 88.135L48.143 87.4353C47.9249 87.3898 47.6994 87.4126 47.4928 87.5012L44.6879 88.8181C44.2191 89.0403 43.5538 88.8181 43.5538 88.4601L43.5803 87.4312C43.6975 87.744 44.2607 87.8839 44.6841 87.6905Z",
    fill: "url(#paint71_linear_2164_2691)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.468 83.5052L43.3107 84.7686C43.5035 84.8509 43.6131 84.9908 43.6093 85.1348L43.5829 86.1719C43.5231 86.0569 43.426 85.9703 43.3107 85.9291L40.468 84.6657C40.2412 84.5669 40.1504 84.4105 40.1769 84.2542V83.1965C40.1958 83.3159 40.2903 83.427 40.468 83.5052Z",
    fill: "url(#paint72_linear_2164_2691)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2086 72.5671C51.1731 72.4971 51.1643 72.4147 51.1841 72.3377C51.2039 72.2607 51.2507 72.1953 51.3145 72.1556L53.4125 70.3942C53.4528 70.3581 53.4872 70.315 53.5145 70.2666C53.5338 70.3006 53.5466 70.3385 53.5519 70.3781C53.5572 70.4176 53.555 70.4579 53.5454 70.4964C53.5358 70.535 53.5191 70.571 53.4962 70.6023C53.4734 70.6335 53.4449 70.6594 53.4125 70.6781L51.3145 72.4395C51.2719 72.4741 51.2359 72.5175 51.2086 72.5671Z",
    fill: "url(#paint73_radial_2164_2691)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4602 71.711L43.3067 72.9744C43.4957 73.0567 43.6052 73.1966 43.6015 73.3407V73.5753C43.5851 73.4969 43.5498 73.4248 43.4993 73.3662C43.4488 73.3076 43.3849 73.2647 43.3142 73.2419L40.4677 71.9785C40.1956 71.8592 40.1237 71.6616 40.2106 71.4888C40.2673 71.5924 40.3556 71.671 40.4602 71.711Z",
    fill: "url(#paint74_radial_2164_2691)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M44.677 75.8963L47.4819 74.5753C47.6886 74.4867 47.914 74.4639 48.1321 74.5094L51.436 75.209C51.5954 75.2583 51.7645 75.257 51.9232 75.2053C52.082 75.1535 52.2238 75.0534 52.332 74.9169C52.5097 75.2626 51.9842 75.5918 51.436 75.4766L48.1321 74.7769C47.914 74.7314 47.6886 74.7542 47.4819 74.8428L44.677 76.1638C44.2083 76.3819 43.543 76.1638 43.543 75.8058V75.5671C43.5732 75.9128 44.2083 76.1103 44.677 75.8963Z",
    fill: "url(#paint75_radial_2164_2691)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M79.0871 67.6325C79.4046 67.8341 79.7335 68.0152 80.07 68.1839C79.9188 69.7107 82.2813 71.5668 82.2813 71.5668C82.5926 70.6994 83.1154 69.941 83.7934 69.3733C85.6004 69.6572 87.2978 69.4803 88.394 68.793C88.6862 68.6352 88.9393 68.4033 89.132 68.1168C89.3247 67.8304 89.4515 67.4978 89.5016 67.1469C89.5923 67.9947 89.2446 68.756 88.394 69.291C87.2978 69.9824 85.6004 70.1552 83.7934 69.8754C83.1153 70.4412 82.5923 71.1983 82.2813 72.0647C82.2813 72.0647 79.9188 70.2087 80.07 68.686C79.7335 68.5173 79.4046 68.3321 79.0871 68.1346C77.0193 66.8341 75.9759 65.2291 76.1347 63.9246C76.2708 65.1386 77.2915 66.5008 79.0871 67.6325Z",
    fill: "url(#paint76_radial_2164_2691)"
  }), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M59.527 62.1464C59.527 62.3069 59.7311 62.4386 59.9882 62.4386C60.2452 62.4386 60.4531 62.3069 60.4531 62.1464C60.4531 61.9859 60.249 61.8542 59.9919 61.8542C59.7349 61.8542 59.527 61.9654 59.527 62.1464Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2164_2691",
    x1: 40.9019,
    y1: 3.12423,
    x2: 6.18806,
    y2: 58.3512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#210243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#25084B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#2C1358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#311B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#351F65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#422C73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#584188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#765FA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#8770B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#7E67AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#5C468D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#442E75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#362066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#311B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#2A1155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#230446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200041"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2164_2691",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-6.73098 26.6023) rotate(180) scale(57.5048 62.6027)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#711F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#6C1E52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#5C1946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#431233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#200918"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2164_2691",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.90532 22.129) rotate(180) scale(33.8784 36.8818)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF8AFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2164_2691",
    x1: 0.166511,
    y1: 56.4098,
    x2: 95.146,
    y2: 29.0971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#3D065F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2164_2691",
    x1: -1.04898,
    y1: 95.872,
    x2: 53.4693,
    y2: -9.95354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#290F52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F001F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2164_2691",
    x1: 33.8125,
    y1: 50.0352,
    x2: 3.94493,
    y2: 50.0352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#290F52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F001F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2164_2691",
    x1: 37.1845,
    y1: 12.0257,
    x2: -14.6036,
    y2: 102.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2164_2691",
    x1: 10.362,
    y1: 33.0031,
    x2: 7.34609,
    y2: 37.8236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#290F52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F001F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2164_2691",
    x1: -0.380309,
    y1: 39.4586,
    x2: 3.30653,
    y2: 39.3127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D065F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F27BD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_2164_2691",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.47202 37.7466) rotate(180) scale(2.16611 2.3581)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#711F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#6C1E52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#5C1946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#431233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#200918"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2164_2691",
    x1: 16.4176,
    y1: 73.9043,
    x2: 38.5671,
    y2: 67.8118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2164_2691",
    x1: 16.8984,
    y1: 74.258,
    x2: 39.0481,
    y2: 68.1654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_2164_2691",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.9725 68.2376) rotate(180) scale(2.03754 2.21817)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_2164_2691",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.7745 72.5587) rotate(180) scale(3.43244 3.73674)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2164_2691",
    x1: 25.375,
    y1: 76.0111,
    x2: 32.5017,
    y2: 61.9225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2164_2691",
    x1: 6.09921,
    y1: -4.46445,
    x2: 27.9838,
    y2: 33.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_2164_2691",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.1183 35.3807) rotate(180) scale(14.4707 15.7536)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#271273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#210F60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#150A3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#0C0522"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#05020F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#010104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2164_2691",
    x1: 30.7075,
    y1: 23.9688,
    x2: 38.841,
    y2: 38.2108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9D9EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEBF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2164_2691",
    x1: 62.7577,
    y1: 38.8866,
    x2: 30.6182,
    y2: 38.8866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9D9EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEBF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2164_2691",
    x1: 20.0863,
    y1: 43.8627,
    x2: -32.348,
    y2: 28.9315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2164_2691",
    x1: 62.7577,
    y1: 44.1584,
    x2: 30.6182,
    y2: 44.1584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9D9EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEBF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2164_2691",
    x1: 31.3206,
    y1: 45.6908,
    x2: 12.4404,
    y2: 40.3118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9D9EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEBF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2164_2691",
    x1: 32.2147,
    y1: 65.7069,
    x2: -0.327934,
    y2: 65.7069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#7733DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#975CED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A56EF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2164_2691",
    x1: 26.7881,
    y1: 57.3607,
    x2: -35.7355,
    y2: 40.1631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#169AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1FC3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2164_2691",
    x1: 62.7577,
    y1: 67.7476,
    x2: 30.6182,
    y2: 67.7476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9D9EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEBF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2164_2691",
    x1: 36.591,
    y1: 68.6365,
    x2: 17.8687,
    y2: 63.4867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9D9EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEBF2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_2164_2691",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.1936 55.0271) rotate(180) scale(14.9432 16.268)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#271273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#210F60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#150A3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#0C0522"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#05020F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#010104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2164_2691",
    x1: 23.2833,
    y1: 43.0556,
    x2: 7.83519,
    y2: 39.8754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#169AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1FC3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_2164_2691",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.205 55.027) rotate(180) scale(14.9432 16.268)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#271273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#210F60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#150A3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#0C0522"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#05020F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#010104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2164_2691",
    x1: 3.23196,
    y1: 5.85696,
    x2: 30.9926,
    y2: 54.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#169AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1FC3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2164_2691",
    x1: 62.7487,
    y1: 62.9492,
    x2: 30.6092,
    y2: 62.9492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9D9EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEBF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2164_2691",
    x1: 30.6356,
    y1: 47.4631,
    x2: 38.8294,
    y2: 61.8079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9D9EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEBF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2164_2691",
    x1: 51.6769,
    y1: 70.6161,
    x2: 27.9944,
    y2: 65.7391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9D9EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEBF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2164_2691",
    x1: 51.6769,
    y1: 47.0272,
    x2: 27.9946,
    y2: 42.1538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9D9EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEBF2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_2164_2691",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.2992 63.5324) rotate(-151.439) scale(9.59098 3.13238)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#972A74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8A266A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#601B4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3D112F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#230A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0F040C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#040103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_2164_2691",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.7224 86.8943) rotate(-151.439) scale(9.59098 3.13238)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#972A74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8A266A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#601B4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3D112F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#230A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0F040C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#040103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2164_2691",
    x1: 26.0209,
    y1: 7.94321,
    x2: -1.67778,
    y2: 86.9789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_2164_2691",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.9892 37.6523) rotate(180) scale(10.3389 11.2555)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_2164_2691",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.9892 61.3195) rotate(180) scale(10.3389 11.2555)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2164_2691",
    x1: 90.8632,
    y1: 54.7554,
    x2: 79.7282,
    y2: 41.0496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#F7AA90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F9B996"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FFE2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F7AA90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2164_2691",
    x1: 75.1849,
    y1: 45.0386,
    x2: 93.6059,
    y2: 39.9268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_2164_2691",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(87.5557 47.9402) scale(6.26001 6.81502)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2164_2691",
    x1: 55.4325,
    y1: 90.2826,
    x2: 41.0192,
    y2: 88.0866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2164_2691",
    x1: 70.0955,
    y1: 90.3714,
    x2: 51.1239,
    y2: 88.4529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2164_2691",
    x1: 49.8264,
    y1: 69.4914,
    x2: 62.5141,
    y2: 83.2727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_2164_2691",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.55 90.6218) rotate(171.556) scale(4.85961 6.70306)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2164_2691",
    x1: 57.1792,
    y1: 63.5583,
    x2: 33.5171,
    y2: 57.0507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2164_2691",
    x1: 76.722,
    y1: 66.5172,
    x2: 52.8376,
    y2: 61.5983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2164_2691",
    x1: 48.4535,
    y1: 36.4504,
    x2: 62.1443,
    y2: 60.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_2164_2691",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.8677 64.9163) rotate(180) scale(7.15975 7.79447)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_2164_2691",
    x1: 63.1426,
    y1: 60.3438,
    x2: 54.4319,
    y2: 66.0827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#741BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#56148B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#3B0E60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#26093E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#150523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#09020F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#020104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_2164_2691",
    x1: 98.3899,
    y1: 87.0691,
    x2: 78.7667,
    y2: 87.0691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FFFBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F9B673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#F9B876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FABE81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FCC993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FED2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#FFC28C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_2164_2691",
    x1: 70.7186,
    y1: 63.8668,
    x2: 91.1668,
    y2: 82.7704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FFBA78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFC987"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_2164_2691",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(92.4632 89.419) rotate(180) scale(3.86339 4.20588)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_2164_2691",
    x1: 53.4765,
    y1: 55.605,
    x2: 49.6007,
    y2: 49.1512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF63CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#DC48C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_2164_2691",
    x1: 52.4416,
    y1: 53.8977,
    x2: 40.7596,
    y2: 45.7398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_2164_2691",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.4575 45.562) rotate(180) scale(1.20969 1.31691)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_2164_2691",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0748 47.7634) rotate(180) scale(2.37402 2.58445)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_2164_2691",
    x1: 60.9579,
    y1: 46.0391,
    x2: 81.3076,
    y2: 40.4426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#169AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1FC3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_2164_2691",
    x1: 61.3017,
    y1: 52.1299,
    x2: 69.4789,
    y2: 50.4471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#169AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1FC3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_2164_2691",
    x1: 61.5419,
    y1: 36.5163,
    x2: 70.8982,
    y2: 51.2059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EC1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#4DC4DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#49CFDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#43E1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#43E2DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#3DABC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#3A91BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#3B96BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3CA0C3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_2164_2691",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.6265 44.965) scale(6.10129 6.64218)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_2164_2691",
    x1: 70.0766,
    y1: 79.6411,
    x2: 38.6024,
    y2: 70.9843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#169AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1FC3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_2164_2691",
    x1: 56.1252,
    y1: 56.9491,
    x2: 69.3765,
    y2: 80.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#169AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1FC3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_2164_2691",
    x1: 67.7928,
    y1: 83.6862,
    x2: 60.9381,
    y2: 81.8008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#169AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1FC3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_2164_2691",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.5084 81.3487) rotate(180) scale(6.86867 7.4776)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_2164_2691",
    x1: 79.6381,
    y1: 68.0647,
    x2: 102.646,
    y2: 61.7365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#169AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1FC3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_2164_2691",
    x1: 110.622,
    y1: 62.3073,
    x2: 87.4217,
    y2: 74.0131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#169AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1FC3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_2164_2691",
    x1: 46.4859,
    y1: 75.9784,
    x2: 47.4879,
    y2: 65.9937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_2164_2691",
    x1: 43.7238,
    y1: 66.686,
    x2: 50.4783,
    y2: 74.3591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_2164_2691",
    x1: 52.3115,
    y1: 84.427,
    x2: 52.6917,
    y2: 80.6385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_2164_2691",
    x1: 47.8746,
    y1: 88.7358,
    x2: 48.237,
    y2: 85.0869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_2164_2691",
    x1: 41.8099,
    y1: 85.5176,
    x2: 42.1141,
    y2: 82.4728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_2164_2691",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.3616 71.4189) rotate(180) scale(1.12275 1.22227)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_2164_2691",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.8853 72.53) rotate(180) scale(1.39111 1.51445)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_2164_2691",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.9469 75.3695) rotate(180) scale(3.17161 3.45279)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_2164_2691",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(85.3396 69.328) rotate(180) scale(5.41708 5.89729)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.a7ce42863b56f9743ba6e59977a4a072.svg";
export { ForwardRef as ReactComponent };